function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyRoundedRectangle = function SvgEmptyRoundedRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 40,
    height: 32,
    rx: 8,
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinejoin: "bevel",
    strokeDasharray: "10 4"
  }));
};
export default SvgEmptyRoundedRectangle;